module.exports = __webpack_public_path__ + "img/image1.7db5af49.png";